import { h, Host } from "@stencil/core";
export class Spinner {
    constructor() {
        this.inline = false;
        this.active = false;
    }
    async toggleActive() {
        this.active = !this.active;
    }
    render() {
        return (h(Host, { key: '86cbe12153aa7c956be5adc0d7d391996b4c5ee6', class: {
                'inline': this.inline,
                'active': this.active,
            } }, h("svg", { key: '03292274888202654218f4b74fb740a3dda37f1a', viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" }, h("circle", { key: '864334bd1bdb6c6768df4e0a37b6242fbb969cf3', "stroke-width": "6", "stroke-linecap": "round", cx: "33", cy: "33", r: "30" })), h("div", { key: '9dbd39dd021a8c0c4bd3fef27cab3f2cd1cb1eb7', class: "spinner-overlay" })));
    }
    static get is() { return "uvex-spinner"; }
    static get originalStyleUrls() {
        return {
            "$": ["./spinner.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["spinner.css"]
        };
    }
    static get properties() {
        return {
            "inline": {
                "type": "boolean",
                "attribute": "inline",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "active": {
                "type": "boolean",
                "attribute": "active",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get methods() {
        return {
            "toggleActive": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=spinner.js.map
